import { Deposit } from './models/deposit';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { EventTypes } from '../../shared/EventTypes';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { ModalErrorEventType } from '../../shared/modal-error/modal-error.event.type';
import { DepositEventType } from './deposit-per-ticket.event.type';
import { TweenMax, Quint } from 'gsap';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'app-deposit-per-ticket',
	templateUrl: './deposit-per-ticket.component.html',
	styleUrls: ['./deposit-per-ticket.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DepositPerTicketComponent implements OnInit, OnDestroy {

	private form: FormGroup;
	private canSend = false;
	public depositData = new Deposit();

	activeBackButton = false;
	flowIndex = 0;
	isModal = true;
	showBalance = true;
	buttonDispatch = false;
	hasSubmited = false;

	flow: Array<string> = [
		DepositEventType.STEPS.DEPOSIT_DATA
	];

	title = [
		'Depósito por boleto',
		'Resumo do Depósito por boleto'
	];

	subtitle = [
		'Transferência de valores para sua Conta Corrente.',
		'Transferência de valores para sua Conta Corrente.',
	];

	constructor() { }

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			this.show();
		});
		AppEventDispatcher.listen(DepositEventType.BUTTONS, data => {

			TweenMax.to('.buttons', .8, { bottom: '-100%', ease: Quint.easeOut });
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, { bottom: 0, ease: Quint.easeOut });
				});
			});
		});

		AppEventDispatcher.listen(DepositEventType.ERROR, (data): any => {

			this.flowIndex = this.flow.findIndex((item, index, array) => {
				if (item === data.step) {
					return true;
				} else {
					return false;
				}
			});

			this.hasSubmited = false;

			this.canSend = false;

		});

		this.listenModal();

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(DepositEventType.BUTTONS);
		AppEventDispatcher.removeListener(DepositEventType.ERROR);
		AppEventDispatcher.removeListener(DepositEventType.MODAL.TRUE_MODAL);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.CANCEL);
	}

	listenModal() {
		AppEventDispatcher.listen(ModalErrorEventType.MODAL.CANCEL, () => {
			this.canSend = false;
		}
		);

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, () => {
			this.readySend();
		}
		);

		AppEventDispatcher.listen(DepositEventType.MODAL.TRUE_MODAL, (data) => {
			this.isModal = data.data;
		}
		);
	}

	onSetForm(form: FormGroup) {
		this.form = form;
		this.canSend = false;
	}

	onSetTitleSubtitle(data) {
		this.title[this.flowIndex] = data.title;
		this.subtitle[this.flowIndex] = data.subtitle;
	}

	show() {
		AppEventDispatcher.dispatch(EventTypes.BALANCE, {show: true});
		AppEventDispatcher.dispatch(DepositEventType.STEPS.DEPOSIT_DATA, { show: true });
	}

	readySend() {
		this.hasSubmited = true;
		if (this.form.valid) {

			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { hide: true });

			this.canSend = true;

			if (this.flow[this.flowIndex] === DepositEventType.STEPS.DEPOSIT_DATA) {
				this.flowIndex++;
				this.hasSubmited = false;
				AppEventDispatcher.dispatch(DepositEventType.SEND.DEPOSIT_DATA_SEND, {});

			} else {
				AppEventDispatcher.dispatch(this.flow[this.flowIndex], { show: false });
				this.flowIndex++;
				this.hasSubmited = false;

				TweenMax.delayedCall(.5, () => {
					AppEventDispatcher.dispatch(this.flow[this.flowIndex], { show: true });
				});
			}
		}

	}

	sendForm(event) {
		this.readySend();
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/deposit-per-ticket.component.ts